import { render } from "./InstructorEditPage.vue?vue&type=template&id=9525f912&scoped=true"
import script from "./InstructorEditPage.vue?vue&type=script&lang=js"
export * from "./InstructorEditPage.vue?vue&type=script&lang=js"

import "./InstructorEditPage.vue?vue&type=style&index=0&id=9525f912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9525f912"]])

export default __exports__